<style lang="less" scoped>
  @import "../../vars.less";

  .news-swipe-item {
    padding: @space-normal;
    padding-bottom: 0;
  }
  .news-swipe-content {
    width: 100%;
    border-radius: 4px;
  }
  .shortcuts {
    position: relative;
    min-height: 80px;
    margin-top: 12px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }
  .shortcuts-content {
    display: inline-block;
  }
  .shortcuts-page {
    display: inline-flex;
    width: 100vw;
  }
  .shortcut-indicator-container {
    position: relative;
    // margin-top: 12px;
  }

  @indicator-height: 4px;
  .shortcut-indicator {
    position: absolute;
    height: @indicator-height;
    background-color: #ddd;
    border-radius: @indicator-height;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
  }
  .shortcut-indicator-core {
    height: @indicator-height;
    width: 50%;
    border-radius: @indicator-height;
    background-color: @primary-color;
    transition: transform .2s linear;
  }

  .block-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 @space-normal;
    margin: 28px 0 0 0;

    .block-title {
      font-size: 16px;
      display: auto;
      margin: 0;
      font-weight: bold;
      color: @text-color;
    }

    .block-more {
      font-size: 14px;
      color: @primary-color;
    }
  }

  .notice-container {
    position: relative;
    width: 100%;
    // min-height: 125px;
    white-space: nowrap;
    overflow: hidden;
  }
  .notice-inner {
    display: inline-block;
  }
  .notice-content {
    display: inline-block;
    vertical-align: top;
    padding: @space-normal;
    &:not(:last-child) {
      padding-right: 0;
    }
  }
  .notice {
    position: relative;
    white-space: normal;
    width: 320px;
    // height: 125px;
    font-size: 14px;
    padding: 12px;
    padding-top: 16px;
    border-radius: 4px;
    box-shadow: 0px 0px 4px #ddd;
    background-color: #fff;
    overflow: hidden;
    display: inline-block;
    &:before {
      content: "";
      display: inline-block;
      height: 6px;
      background-image: url("/images/bg2.png");
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
  .notice-time {
    font-size: 12px;
    margin: 0 0 @space-medium 0;
    color: @text-color-secondary;
  }
  .notice-title {
    margin: 0 0 @space-medium 0;
    color: @text-color;
    font-size: 14px;
  }
  .notice-abstract {
    margin: 0;
    font-size: 12px;
    color: @text-color-secondary;
  }
  .shortcut {
    overflow: hidden;
    &.disabled {
      filter: grayscale(100%);
    }
  }
</style>
<style lang="less">
  @import "../../vars.less";
  .van-tabbar-item__icon {
    height: 20px;
  }
  .van-grid-item__text {
    margin-top: 0 !important;
  }
  .van-grid-item__content {
    padding-bottom: @space-medium !important;
    background-color: transparent;
  }
</style>

<template>
  <div class="home">
    <!-- Banner滚动图 -->
    <van-swipe :autoplay="4500" indicator-color="white">
      <van-swipe-item class="news-swipe-item">
        <img class="news-swipe-content" src="/images/banner/01.jpg" />
      </van-swipe-item>
      <van-swipe-item class="news-swipe-item">
        <img class="news-swipe-content" src="/images/banner/02.jpg" />
      </van-swipe-item>
      <van-swipe-item class="news-swipe-item">
        <img class="news-swipe-content" src="/images/banner/03.jpg" />
      </van-swipe-item>
      <van-swipe-item class="news-swipe-item">
        <img class="news-swipe-content" src="/images/banner/04.jpg" />
      </van-swipe-item>
      <van-swipe-item class="news-swipe-item">
        <img class="news-swipe-content" src="/images/banner/05.jpg" />
      </van-swipe-item>
    </van-swipe>
    <!-- 快捷功能区 -->
    <div class="shortcuts" ref="shortcuts">
      <div class="shortcuts-content" ref="shortcutsContent">
        <van-grid class="shortcuts-page" :border="false" icon-size="36px">
          <van-grid-item class="shortcut"
            v-for="item of shortcuts.slice(0, 8)" :key="item.code"
            :class="{ disabled: !$auth(item.code) }"
            :icon="`/images/shortcut-icons/${item.icon}`" clickable
            :text="item.name" @click="() => $auth(item.code) && go2page(item)" />
          <van-grid-item class="shortcut" v-if="shortcuts.length < 8 && !shortcutsLoading"
            icon="/images/shortcut-icons/more.png" clickable
            :text="$t('更多')"  @click="go2SetShortcuts" />
        </van-grid>
        <van-grid v-if="shortcuts.length >= 8"
          class="shortcuts-page"
          :border="false" icon-size="36px">
          <van-grid-item class="shortcut"
            v-for="item of shortcuts.slice(8, 16)" :key="item.code"
            :class="{ disabled: !$auth(item.code) }"
            :icon="`/images/shortcut-icons/${item.icon}`" clickable
            :text="item.name" @click="() => $auth(item.code) && go2page(item)" />
          <van-grid-item class="shortcut" v-if="shortcuts.length < 16"
            icon="/images/shortcut-icons/more.png" clickable
            :text="$t('更多')" @click="go2SetShortcuts" />
        </van-grid>
      </div>
      <block-loading :loading="shortcutsLoading"/>
    </div>
    <div class="shortcut-indicator-container" v-show="shortcuts.length >= 8">
      <div class="shortcut-indicator" ref="indicator" :style="{width: indicatorWidth + 'px'}">
        <div class="shortcut-indicator-core" :style="{
          width: indicatorCoreWidthRatio * 100 + '%',
          transform: `translateX(${indicatorPos})`
        }"></div>
      </div>
    </div>
    <!-- 通知公告 -->
    <div class="block-title-container">
      <h3 class="block-title">{{ $t('通知公告') }}</h3>
      <router-link :to="{ name: 'advertisement-list', params: { stackType: 'push' } }" class="block-more">
        {{ $t('查看全部') }}
        <van-icon name="arrow"/>
      </router-link>
    </div>
    <div class="notice-container" ref="notice">
      <div class="notice-inner">
        <div class="notice-content"
          v-for="item of advertisements" :key="item.id">
          <div class="notice" @click="() => go2advertisement(item)">
            <p class="notice-time">{{ item.create_time }}</p>
            <h4 class="notice-title  van-multi-ellipsis--l2">{{ item.title  }}</h4>
            <p class="notice-abstract van-multi-ellipsis--l2">{{ item.text.slice(0, 100) }}</p>
          </div>
        </div>
      </div>
      <block-loading :loading="advertisementsLoading"/>
      <oh-empty v-show="!advertisements.length && !advertisementsLoading" :message="$t('暂无通知公告')" />
    </div>
    <van-dialog v-model="showGestureTips" :title="$t('手势登录')" width="90%"
      show-cancel-button :cancel-button-text="$t('不再提示')" :confirm-button-text="$t('去设置')"
      :get-container="getContainer" theme="round" confirm-button-color="#009999"
      @confirm="go2SetGesture" :message="$t('还未设置手势登录密码，现在去设置吗？')"
      @cancel="doNotShowTipsAgain" />
  </div>
</template>

<script>
import localforage from 'localforage'
import { Swipe, SwipeItem, Grid, GridItem, Icon, Dialog } from 'vant'
import BScroll from '@better-scroll/core'
import { BS_COMMON_CONFIG, LF_KEYS, LS_KEYS } from '../../constants'
import BlockLoading from '../../components/BlockLoading'
import Empty from '../../components/Empty'
import originShortcuts from './shortcuts'
import ls from '../../utils/local-storage'

export default {
  name: 'home',
  components: {
    BlockLoading,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'van-grid': Grid,
    'van-grid-item': GridItem,
    'van-icon': Icon,
    'van-dialog': Dialog.Component,
    'oh-empty': Empty
  },
  data () {
    return {
      indicatorWidth: 60,
      indicatorCoreWidthRatio: 0,
      indicatorPos: '0px',
      showGestureTips: false,
      originShortcuts,
      shortcutsLoading: false,
      savedShortcuts: [],
      advertisementsLoading: false,
      advertisements: []
    }
  },
  computed: {
    shortcuts () {
      return this.originShortcuts
        .filter(sc => this.savedShortcuts.findIndex(it => it.op_code === sc.code) !== -1)
        .map(it => {
          const s = this.savedShortcuts.find(s => s.op_code === it.code)
          return {
            ...it,
            name: s.op_name,
            code: s.op_code
          }
        })
    }
  },
  methods: {
    getContainer () { return window.document.body },
    initShortcutScroll () {
      this.shortcutBs = new BScroll(this.$refs.shortcuts, {
        scrollX: true,
        probeType: 3,
        tap: 'tap',
        ...BS_COMMON_CONFIG
      })

      this.shortcutBs.on('scroll', () => {
        const containerWidth = window.innerWidth
        const ratio = -this.shortcutBs.x / containerWidth
        this.indicatorPos = Math.round(this.indicatorWidth * (1 - this.indicatorCoreWidthRatio) * ratio) + 'px'
      })

      this.shortcutBs.on('refresh', () => {
        this.initIndicator()
      })
    },
    initIndicator () {
      const containerWidth = window.innerWidth
      const contentWidth = this.$refs.shortcutsContent.children.length * containerWidth
      this.indicatorCoreWidthRatio = containerWidth / contentWidth
    },
    initNoticeScroll () {
      this.noticeBs = new BScroll(this.$refs.notice, {
        scrollX: true,
        probeType: 0,
        ...BS_COMMON_CONFIG
      })
    },
    checkGesture () {
      if (
        this.$root.password &&
        !ls.get(LS_KEYS.ENCRYPTED_PWD) &&
        !ls.get(LS_KEYS.NO_LOGNGER_SHOW_GESTURE_TIPS)
      ) {
        this.showGestureTips = true
      }
    },
    go2SetGesture () {
      this.showGestureTips = false
      this.$nextTick(() => {
        this.$router.push({
          name: 'gesture-set',
          params: {
            stackType: 'push'
          }
        })
      })
    },
    doNotShowTipsAgain () {
      ls.set(LS_KEYS.NO_LOGNGER_SHOW_GESTURE_TIPS, true)
    },
    getAvaliableShortcuts () {
      this.$apis.home
        .getAvaliableShortCuts(loading => (this.shortcutsLoading = loading))
        .then(res => {
          if (res) { this.savedShortcuts = res }
        })
    },
    getAdvertisement () {
      this.$apis.home.getAdvertisement(
        loading => (this.advertisementsLoading = loading)
      ).then(res => {
        if (res) {
          this.advertisements = res
          localforage.setItem(LF_KEYS.ADVERTISEMENTS, res)
        }
      })
    },
    go2SetShortcuts () {
      this.$router.push({
        name: 'set-shortcuts',
        params: {
          stackType: 'push'
        }
      })
    },
    go2page (shortcut) {
      this.$router.push({
        name: shortcut.route,
        params: shortcut.push ? { stackType: 'push' } : undefined
      })
    },
    go2advertisement (adv) {
      this.$router.push({
        name: 'advertisement',
        query: { id: adv.id },
        params: {
          stackType: 'push'
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAvaliableShortcuts()
      vm.getAdvertisement()
    })
  },
  mounted () {
    this.initShortcutScroll()
    this.initIndicator()
    this.initNoticeScroll()
    this.checkGesture()
  },
  destroyed () {
    this.shortcutBs.destroy()
    this.noticeBs.destroy()
  }
}
</script>
